export enum SocialMediaSite {
  LinkedIn = 100,
  Facebook = 200,
  Instagram = 300,
  Twitter = 400,
  TikTok = 500,
}
